import { Component, OnInit, PLATFORM_ID, Inject } from '@angular/core';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';
// ngrx store
import { Store } from '@ngrx/store';
// services
import { DataStorageService } from '../../../shared/services/data-storage.service';
// models
import { AppState } from '../../../booking/models/app-state.interface';
declare var ga: any;

@Component({
  selector: 'app-verify-email-section',
  templateUrl: './verify-email-section.component.html',
  styleUrls: ['./verify-email-section.component.scss'],
  providers: [DataStorageService]
})
export class VerifyEmailSectionComponent implements OnInit {

  constructor(
    private _dataStorageService: DataStorageService,
    private _appStore: Store<AppState>,
    @Inject(PLATFORM_ID) private platformId: Object
  ) { }

  ngOnInit() {

    if (isPlatformBrowser(this.platformId)) {
      ga('set', 'page', '/login');
      ga('send', 'pageview');

      this._dataStorageService.removeCookie('DataID');
      this._dataStorageService.removeCookie('DataT');
      this._dataStorageService.removeCookie('PortrE');
    }
    this._appStore.dispatch({ type: 'RESET_USER_STATE' });
  }

}
